import React, { Component } from 'react';
import TeamBanner from './TeamBanner';
import Standing from './Standing';
import PlayerBoards from './PlayerBoards';
import UpcomingGames from './UpcomingGames';
import axios from 'axios';
import AD from 'react-google-publisher-tag';
import _ from 'lodash';
import { reduceMetadata } from '~/tools/mll/helpers';
import './index.css';

class TeamDetail extends Component {
  state = {
    items: this.props.data && this.props.data.contentData[0].gist,
  }

  componentDidMount = () => {
    const meta = reduceMetadata(_.get(this.state.items, 'metadata', []));
    axios.get(`/season/standings/${meta.seasonID}`).then((res) => {
      this.setState({ 
        data: res.data,
        seasonId: meta.seasonID 
      });
    }).catch((err) => {
      console.log(err);
    })
  }

  render() {
    return (
      <div className='team-detail'>
      {this.state.data && 
        <div>
          <TeamBanner 
            teamId={this.state.items.dataId} 
            logo={this.state.items.imageGist._1x1} 
            social={this.state.items}
            data={this.state.data}
          />
          <div className="banner-ad-container">
            <AD path={_.get(this.props.data, 'metadataMap.bannerAdTag')} dimensions={[[970,90],[728,90],[320,50]]}/>
          </div>
          <div className='boards-wrapper'>
            <UpcomingGames />
            <PlayerBoards teamId={this.state.items.dataId} seasonId={this.state.seasonId} />
            <Standing teamId={this.state.items.dataId} data={this.state.data}/>
          </div>
        </div>}
      </div>
    )
  }
}

export default TeamDetail;